$(function () {
    const ns = "slider-preview";
    const activeClass = "active";

    $(`.${ns}`).each(function () {
        const $main = $(this).find(`.${ns}__main`);
        const $tape = $(this).find(`.${ns}__tape`);

        const $edgeL = $tape.find(`.${ns}__edge--l`);
        const $edgeR = $tape.find(`.${ns}__edge--r`);

        const setEdge = function (swiper) {
            $edgeL.toggleClass(activeClass, !swiper.isBeginning);
            $edgeR.toggleClass(activeClass, !swiper.isEnd);
        };

        const initialSlide = $(this).data("initial") || 0;

        const tape = new Swiper($tape.find(".swiper")[0], {
            initialSlide,
            slidesPerView: "auto",
            watchSlidesProgress: true,
            freeMode: true,
            navigation: {
                nextEl: $tape.find(`.${ns}__next`)[0],
                prevEl: $tape.find(`.${ns}__prev`)[0],
            },
            on: {
                afterInit: setEdge,
                transitionStart: setEdge,
                sliderMove: setEdge,
            },
        });

        new Swiper($main.find(".swiper")[0], {
            initialSlide,
            thumbs: {
                swiper: tape,
            },
            navigation: {
                nextEl: $main.find(`.${ns}__next`)[0],
                prevEl: $main.find(`.${ns}__prev`)[0],
            },
        });
    });
});
